import axios from 'axios'
import type { TOrder, TShipToAddress } from '../../types/TOrderCalc'
import type { THydraOrder } from '../../types/THydraOrder'

const getSavedCreditCards = async ({ userCountry, token }: { userCountry: string; token: string }) => {
    const response = await axios.get(`https://hydra.unicity.net/v5a/customers/me/creditcardaliases/${userCountry}`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'x-application': `asia.spotlight-${userCountry.toLowerCase()}`
        }
    })
    return response
}

const createPayment = ({ uuid, sourcePath, countryCode3Alpha }: { uuid: string; sourcePath: string; countryCode3Alpha: string }) => {
    return axios.post(`https://member-calls2.unicity.com/hot/payment_router/hydra-value/spotlight/${countryCode3Alpha}`, {
        uuid: uuid,
        source_path: sourcePath
    })
}

const orderCal = ({ order, countryCode3Alpha }: { order: TOrder; countryCode3Alpha: string }) => {
    return axios.post(
        'https://hydra.unicity.net/v5a/quotes?expand=item',
        {
            order
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'x-application': `asia.spotlight-${countryCode3Alpha.toLowerCase()}`
            }
        }
    )
}

const requestWorldPayDDC = ({ cardNumber, countryCode3Alpha }: { cardNumber: string; countryCode3Alpha: string }) => {
    return axios.post(
        'https://hydra.unicity.net/v5a/ddc',
        {
            bin: cardNumber
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'x-application': `asia.spotlight-${countryCode3Alpha.toLowerCase()}`
            }
        }
    )
}
export type TUpdateLog = {
    payments_id: string
    payment_status: string
    order_number: string
    approval_code: string
    dist_id: string
    dist_status: string
    hydra_curl: string
    hydra_response_header: string
    hydra_response_body: string
}
const updateLog = ({ data }: { data: TUpdateLog }) => {
    const url = `https://member-calls2.unicity.com/hot/payment_router/hydra-log`

    return axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const createOrder = ({ data, token, countryCode3Alpha }: { data: THydraOrder; token: string; countryCode3Alpha: string }) => {
    return axios.post(`https://hydra.unicity.net/v5a/customers/me/orders`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            'x-application': `asia.spotlight-${countryCode3Alpha.toLowerCase()}`
        }
    })
}

const updateUuid = ({ uuid, data }: { uuid: string; data: { [key: string]: string | TShipToAddress } }) => {
    return axios.put(`https://member-calls2.unicity.com/hot/formatV2/JPN/spotlight/address`, {
        uuid: uuid,
        ...data
    })
}

const getPaymentDetail = ({ paymentId, baId, type }: { paymentId: string; baId: string; type: string }) => {
    return axios.post(
        `https://member-calls2.unicity.com/hot/payment_router/detail/hydra`,
        {
            payment_id: paymentId,
            ba_id: baId,
            type: type
        },
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    )
}

const updateLogByOrder = ({ paymentId, orderNumber }: { paymentId: string; orderNumber: string }) => {
    return axios.post(`https://member-calls2.unicity.com/hot/payment_router/hydra-log-by-order`, {
        payment_id: paymentId,
        order_number: orderNumber,
        payment_status: 'success'
    })
}

const getOrderDetailByOrderNumber = (orderNumber: string) => {
    const url = `https://member-calls2.unicity.com/hot/formatV2/order/data?order_number=${orderNumber}`

    return axios.get(url)
}

export const paymentApis = {
    getSavedCreditCards,
    createPayment,
    orderCal,
    requestWorldPayDDC,
    updateLog,
    createOrder,
    updateUuid,
    getPaymentDetail,
    updateLogByOrder,
    getOrderDetailByOrderNumber
}
